import { render, staticRenderFns } from "./AdminTemplateAdd.vue?vue&type=template&id=ae96e8a4"
import script from "./AdminTemplateAdd.vue?vue&type=script&lang=js"
export * from "./AdminTemplateAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports